export default __webpack_public_path__ + "static/media/mecha_927_2.d1cef9ce.jpg";